import React from "react";
import Accordion from 'react-bootstrap/Accordion';

import Icontv from '../../../assets/icons/Icontv2.png';
import IconTv from '../../../assets/images/TV_Icon.png';
import Icon2Tv from '../../../assets/images/TV_Icon2.png';
import TvCamara from '../../../assets/logos/TV_Camara.png';
import TV_Senado from '../../../assets/logos/TV_Senado.png';
import TV_Justica from '../../../assets/logos/TV_Justica.jpg';
import TV_Brasil from '../../../assets/logos/TV_Brasil.png';
import TV_Escola from '../../../assets/logos/TV_Escola.png';
import TV_Alego from '../../../assets/logos/TV_Alego.jpg';
import TV_Goiania from '../../../assets/logos/TV_Goiania.fw.png';
import TV_Serra_Dourada from '../../../assets/logos/TV_Serra_Dourada.png';
import TV_Anhanguera from '../../../assets/logos/TV_Anhanguera.png';
import TV_UFG from '../../../assets/logos/TV_UFG.png';
import TV_Brasil_Central from '../../../assets/logos/TV_Brasil_Central.png';
import Fonte_TV from '../../../assets/logos/Fonte_TV.jpg';
import PUC_TV from '../../../assets/logos/PUC_TV.jpg';
import TV_Sucesso from '../../../assets/logos/TV_Sucesso.png';
import Rede_TV from '../../../assets/logos/Rede_TV.png';
import TV_Evangelizar from '../../../assets/logos/TV_Evangelizar.png';
import Rede_Seculo_21 from '../../../assets/logos/Rede_Seculo_21.png';
import Canal_Promessas from '../../../assets/logos/Canal_Promessas.png';
import TV_Cancao_Nova from '../../../assets/logos/TV_Cancao_Nova.png';
import Rede_Vida from '../../../assets/logos/Rede_Vida.png';
import TV_Aparecida from '../../../assets/logos/TV_Aparecida.png';
import Rede_Super from '../../../assets/logos/Rede_Super.png';
import Canal_Saude from '../../../assets/logos/Canal_Saude.png';
import Agro_Canal from '../../../assets/logos/AGRO_CANAL.png';
import Canal_do_Boi from '../../../assets/logos/Canal_do_Boi.png';
import JP_News from '../../../assets/logos/JP_News.jpg';
import Boas_Novas from '../../../assets/logos/BOAS_NOVAS.jpg';
import Novo_Tempo from '../../../assets/logos/NOVO_TEMPO.png';
import Futura from '../../../assets/logos/TV_Futura_icon.png';
import VGSTV from '../../../assets/logos/VGSTV.png';
import TV_Mundo_Maior from '../../../assets/logos/TV_Mundo_Maior.png';
import SBN_TV from '../../../assets/logos/SBN_TV.jpg';
import REDE_CNT from '../../../assets/logos/REDE_CNT.png';
import TV_CI from '../../../assets/logos/TV_CI.png';
import Nick_Jr from '../../../assets/logos/Nick_Jr.png';
import Space from '../../../assets/logos/Space.png';
import TBS from '../../../assets/logos/TBS.png';
import GigaTV from '../../../assets/logos/GigaTV.png';
import Clima_Tempo from '../../../assets/logos/Clima_Tempo.png';
import Sem_Imagem from '../../../assets/logos/Sem_Imagem.png';

import './styles.css';
import { ListGroup } from "react-bootstrap";


const Canais = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="start"></div>
        <div className="col-sm-12 col-md-4 imgIcon">
          <img src={IconTv} alt="foto" />
        </div>
        <div className="col-sm-12 col-md-8 icontv">
          <h4> Canais Fechados</h4>
          <Accordion>
            <Accordion.Item eventKey="0" className="accordion-foto">
              <Accordion.Header><img src={Icontv} alt="Foto" />   Esportes </Accordion.Header>
              <Accordion.Body>
                <ListGroup>
                  <ListGroup.Item><img src={'https://gigabytetelecom.com.br/img/canais/full/31.png'} alt='foto' /> 154 - Fish TV</ListGroup.Item>
                  <ListGroup.Item><img src={'https://gigabytetelecom.com.br/img/canais/full/28.png'} alt='foto' /> 170 - ESPN Extra</ListGroup.Item>
                  <ListGroup.Item><img src={'https://gigabytetelecom.com.br/img/canais/full/6.png'} alt='foto' /> 172 - Band Sports</ListGroup.Item>
                  <ListGroup.Item><img src={'https://gigabytetelecom.com.br/img/canais/full/27.png'} alt='foto' /> 173 - ESPN Internacional HD</ListGroup.Item>
                  <ListGroup.Item><img src={'https://gigabytetelecom.com.br/img/canais/full/27.png'} alt='foto' /> 174 - ESPN Brasil HD</ListGroup.Item>
                  <ListGroup.Item><img src={'https://gigabytetelecom.com.br/img/canais/full/29.png'} alt='foto' /> 175 - ESPN 2 HD</ListGroup.Item>
                </ListGroup>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1" className="accordion-foto">
              <Accordion.Header><img src={Icontv} alt="Foto" />   Filmes e Séries </Accordion.Header>
              <Accordion.Body>
                <ListGroup>
                  <ListGroup.Item><img src={'https://gigabytetelecom.com.br/img/canais/full/50.png'} alt='foto' /> 130 - TNT HD</ListGroup.Item>
                  <ListGroup.Item><img src={Space} alt='foto' /> 131 - Space HD</ListGroup.Item>
                  <ListGroup.Item><img src={TBS} alt='foto' /> 132 - TBS</ListGroup.Item>
                  <ListGroup.Item><img src={'https://gigabytetelecom.com.br/img/canais/full/51.png'} alt='foto' /> 133 - TNT Séries</ListGroup.Item>
                  <ListGroup.Item><img src={'https://gigabytetelecom.com.br/img/canais/full/48.png'} alt='foto' /> 135 - TCM</ListGroup.Item>
                  <ListGroup.Item><img src={'https://gigabytetelecom.com.br/img/canais/full/43.png'} alt='foto' /> 136 - Prime Box</ListGroup.Item>
                  <ListGroup.Item><img src={'https://gigabytetelecom.com.br/img/canais/full/42.png'} alt='foto' /> 140 - Paramount HD</ListGroup.Item>
                </ListGroup>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2" className="accordion-foto">
              <Accordion.Header><img src={Icontv} alt="Foto" />   Infantil </Accordion.Header>
              <Accordion.Body>
                <ListGroup>

                  <ListGroup.Item><img src={'https://gigabytetelecom.com.br/img/canais/full/22.png'} alt='foto' /> 116 - Disney Junior</ListGroup.Item>
                  <ListGroup.Item><img src={'https://gigabytetelecom.com.br/img/canais/full/52.png'} alt='foto' /> 117 - TV Ra Tim Bum</ListGroup.Item>
                  <ListGroup.Item><img src={'https://gigabytetelecom.com.br/img/canais/full/17.png'} alt='foto' /> 115 - Discovery Kids HD</ListGroup.Item>
                  <ListGroup.Item><img src={'https://cn.i.cdn.ti-platform.com/content/1063/boomerang/showpage/ve/showlogo.9c92fa00.png?imwidth=320'} alt='foto' /> 118 - Boomerang</ListGroup.Item>
                  <ListGroup.Item><img src={'https://gigabytetelecom.com.br/img/canais/full/22.png'} alt='foto' /> 119 - Disney HD</ListGroup.Item>
                  <ListGroup.Item><img src={'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b9/Disney_XD_-_2015.svg/300px-Disney_XD_-_2015.svg.png'} alt='foto' /> 120 - Disney XD</ListGroup.Item>
                  <ListGroup.Item><img src={'https://cn.i.cdn.ti-platform.com/content/1293/tooncast/showpage/ar/showlogo.ca8dd28c.png?imwidth=320'} alt='foto' /> 122 - Tooncast</ListGroup.Item>
                  <ListGroup.Item><img src={'https://gigabytetelecom.com.br/img/canais/full/41.png'} alt='foto' /> 123 - Nickelodeon HD</ListGroup.Item>
                  <ListGroup.Item><img src={Nick_Jr} alt='foto' /> 125 - Nick Jr</ListGroup.Item>
                  <ListGroup.Item><img src={'https://cncdn.dmti.cloud/8229cdd007d7da0bb2da724fbf24510a826d05a5/static/media/cn-logo.3f4d7cfb.svg'} alt='foto' /> 126 - Cartoon Network HD</ListGroup.Item>
                </ListGroup>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="3" className="accordion-foto">
              <Accordion.Header><img src={Icontv} alt="Foto" />   Notícias </Accordion.Header>
              <Accordion.Body>
                <ListGroup>
                  <ListGroup.Item><img src={'https://gigabytetelecom.com.br/img/canais/full/5.png'} alt='foto' /> 110 - Band News</ListGroup.Item>
                </ListGroup>
                <ListGroup>
                  <ListGroup.Item>
                    <img src={'https://gigabytetelecom.com.br/img/canais/full/9.png'} alt='foto' /> 111 - CNNi
                  </ListGroup.Item>
                </ListGroup>
                <ListGroup>
                  <ListGroup.Item><img src={'https://upload.wikimedia.org/wikipedia/commons/thumb/7/76/Record_News_logo_2022.svg/375px-Record_News_logo_2022.svg.png'} alt='foto' /> 112 - Record News HD</ListGroup.Item>
                </ListGroup>
                <ListGroup>
                  <ListGroup.Item><img src={'https://gigabytetelecom.com.br/img/canais/full/8.png'} alt='foto' /> 114 - CNN Brasil HD</ListGroup.Item>
                </ListGroup>
                <ListGroup>
                  <ListGroup.Item><img src={Clima_Tempo} alt='foto' /> 113 - Clima Tempo HD</ListGroup.Item>
                </ListGroup>

              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="4" className="accordion-foto">
              <Accordion.Header><img src={Icontv} alt="Foto" />   Documentários </Accordion.Header>
              <Accordion.Body>
                <ListGroup>
                  <ListGroup.Item><img src={'https://gigabytetelecom.com.br/img/canais/full/18.png'} alt='foto' /> 102 - Discovery Science</ListGroup.Item>
                  <ListGroup.Item><img src={'https://gigabytetelecom.com.br/img/canais/full/19.png'} alt='foto' /> 103 - Discovery Theater HD</ListGroup.Item>
                  <ListGroup.Item><img src={'https://upload.wikimedia.org/wikipedia/commons/0/0a/Investiga%C3%A7%C3%A3o_Discovery_1.png'} alt='foto' /> 129 - Investigacao Discovery HD</ListGroup.Item>
                  <ListGroup.Item><img src={'https://gigabytetelecom.com.br/img/canais/full/20.png'} alt='foto' /> 180 - Discovery Turbo HD</ListGroup.Item>
                  <ListGroup.Item><img src={'https://gigabytetelecom.com.br/img/canais/full/1.png'} alt='foto' /> 181 - A&amp;E HD</ListGroup.Item>
                  <ListGroup.Item><img src={'https://gigabytetelecom.com.br/img/canais/full/History.png'} alt='foto' /> 182 - History HD</ListGroup.Item>
                  <ListGroup.Item><img src={'https://gigabytetelecom.com.br/img/canais/full/History2.png'} alt='foto' /> 186 - H2 HD</ListGroup.Item>
                  <ListGroup.Item><img src={'https://gigabytetelecom.com.br/img/canais/full/36.png'} alt='foto' /> 187 - Lifetime HD</ListGroup.Item>
                  <ListGroup.Item><img src={'https://gigabytetelecom.com.br/img/canais/full/25.png'} alt='foto' /> 188 - E! HD</ListGroup.Item>
                </ListGroup>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="5" className="accordion-foto">
              <Accordion.Header><img src={Icontv} alt="Foto" />   Entretenimento e Variedades </Accordion.Header>
              <Accordion.Body>
                <ListGroup>
                  <ListGroup.Item><img src={'https://gigabytetelecom.com.br/img/canais/full/15.png'} alt='foto' /> 100 - Discovery Channel HD</ListGroup.Item>
                  <ListGroup.Item><img src={'https://gigabytetelecom.com.br/img/canais/full/3.png'} alt='foto' /> 101 - Animal Planet HD</ListGroup.Item>
                  <ListGroup.Item><img src={'https://gigabytetelecom.com.br/img/canais/full/33.png'} alt='foto' /> 104 - HGTV</ListGroup.Item>
                  <ListGroup.Item><img src={'https://gigabytetelecom.com.br/img/canais/full/16.png'} alt='foto' /> 145 - Discovery Home &amp; Healt HD</ListGroup.Item>
                  <ListGroup.Item><img src={'https://gigabytetelecom.com.br/img/canais/full/49.png'} alt='foto' /> 146 - TLC HD</ListGroup.Item>
                  <ListGroup.Item><img src={'https://gigabytetelecom.com.br/img/canais/full/4.png'} alt='foto' /> 151 - Arte 1</ListGroup.Item>
                  <ListGroup.Item><img src={'https://upload.wikimedia.org/wikipedia/pt/1/1c/LOGOCHEFTV.jpg'} alt='foto' /> 155 - Chef TV</ListGroup.Item>
                  <ListGroup.Item><img src={'https://gigabytetelecom.com.br/img/canais/full/39.png'} alt='foto' /> 160 - Music Box Brazil</ListGroup.Item>
                  <ListGroup.Item><img src={'https://gigabytetelecom.com.br/img/canais/full/37.png'} alt='foto' /> 161 - MTV HD</ListGroup.Item>
                  <ListGroup.Item><img src={'https://gigabytetelecom.com.br/img/canais/full/38.png'} alt='foto' /> 162 - MTV Live HD</ListGroup.Item>
                  <ListGroup.Item><img src={'https://gigabytetelecom.com.br/img/canais/full/14.png'} alt='foto' /> 139 - Comedy Central</ListGroup.Item>
                  <ListGroup.Item><img src={'https://gigabytetelecom.com.br/img/canais/full/12.png'} alt='foto' /> 141 - Cinebrasil TV</ListGroup.Item>
                  <ListGroup.Item><img src={'https://gigabytetelecom.com.br/img/canais/full/57.png'} alt='foto' /> 178 - Woohoo</ListGroup.Item>
                  <ListGroup.Item><img src={'https://gigabytetelecom.com.br/img/canais/full/55.png'} alt='foto' /> 152 - Travel Box Brazil</ListGroup.Item>
                  <ListGroup.Item><img src={'https://gigabytetelecom.com.br/img/canais/full/30.png'} alt='foto' /> 153 - Fashion TV Brazil</ListGroup.Item>
                </ListGroup>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
        <div className="end"></div>
      </div>
      <hr />
      <div className="row">
        <div className="col-sm-12 col-md-4 imgIcon">
          <img src={Icon2Tv} alt="foto" />
        </div>
        <div className="col-sm-12 col-md-8">
          <h4 className="py-4">Canais Abertos</h4>
          <Accordion>
            <Accordion.Item eventKey="6" className="accordion-foto">
              <Accordion.Header><img src={Icontv} alt="Foto" />   Canais de TV aberta </Accordion.Header>
              <Accordion.Body>
                <ListGroup vertical>
                  <ListGroup.Item><img src={TvCamara} alt='foto' /> 1 - TV Câmara</ListGroup.Item>
                  <ListGroup.Item><img src={TV_Senado} alt='foto' /> 2 - TV Senado HD</ListGroup.Item>
                  <ListGroup.Item><img src={TV_Justica} alt='foto' /> 3 - TV Justiça HD</ListGroup.Item>
                  <ListGroup.Item><img src={TV_Brasil} alt='foto' /> 4 - TV Brasil HD</ListGroup.Item>
                  <ListGroup.Item><img src={TV_Escola} alt='foto' /> 6 - TV Escola</ListGroup.Item>
                  <ListGroup.Item><img src={TV_Alego} alt='foto' /> 7 - TV Assembléia Legislativa GO HD</ListGroup.Item>
                  <ListGroup.Item><img src={Sem_Imagem} alt='foto' /> 8 - Reservado TV Cidadania</ListGroup.Item>
                  <ListGroup.Item><img src={Sem_Imagem} alt='foto' /> 9 - Reservado TV Universitária</ListGroup.Item>
                  <ListGroup.Item><img src={Sem_Imagem} alt='foto' /> 10 - Reservado TV Comunitária</ListGroup.Item>
                  <ListGroup.Item><img src={GigaTV} alt='foto' /> 11 - Gigabyte TV</ListGroup.Item>
                  <ListGroup.Item><img src={TV_Anhanguera} alt='foto' /> 12 - Globo Local Analógico</ListGroup.Item>
                  <ListGroup.Item><img src={TV_Serra_Dourada} alt='foto' /> 13 - SBT TV Serra Dourada </ListGroup.Item>
                  <ListGroup.Item><img src={TV_Goiania} alt='foto' /> 14 - TV Goiânia HD</ListGroup.Item>
                  <ListGroup.Item><img src={TV_UFG} alt='foto' /> 15 - TV UFG GO HD</ListGroup.Item>
                  <ListGroup.Item><img src={TV_Brasil_Central} alt='foto' /> 16 - TV Brasil Central HD</ListGroup.Item>
                  <ListGroup.Item><img src={Fonte_TV} alt='foto' /> 17 - Fonte TV HD</ListGroup.Item>
                  <ListGroup.Item><img src={PUC_TV} alt='foto' /> 18 - Puc TV HD</ListGroup.Item>
                  <ListGroup.Item><img src={TV_Sucesso} alt='foto' /> 19 - Tv Sucesso SD</ListGroup.Item>
                  <ListGroup.Item><img src={Sem_Imagem} alt='foto' /> 20 - Informativo</ListGroup.Item>
                  <ListGroup.Item><img src={Rede_TV} alt='foto' /> 21 - Rede Tv</ListGroup.Item>
                  <ListGroup.Item><img src={TV_Evangelizar} alt='foto' /> 23 - TV Evangelizar</ListGroup.Item>
                  <ListGroup.Item><img src={Sem_Imagem} alt='foto' /> 24 - Canal 7</ListGroup.Item>
                  <ListGroup.Item><img src={Rede_Seculo_21} alt='foto' /> 25 - Rede Século 21</ListGroup.Item>
                  <ListGroup.Item><img src={Canal_Promessas} alt='foto' /> 26 - Canal Promessas HD</ListGroup.Item>
                  <ListGroup.Item><img src={TV_Cancao_Nova} alt='foto' /> 27 - TV Canção Nova</ListGroup.Item>
                  <ListGroup.Item><img src={Rede_Vida} alt='foto' /> 28 - Rede vida HD</ListGroup.Item>
                  <ListGroup.Item><img src={TV_Aparecida} alt='foto' /> 29 - Tv Aparecida HD</ListGroup.Item>
                  <ListGroup.Item><img src={Rede_Super} alt='foto' /> 30 Rede Super</ListGroup.Item>
                  <ListGroup.Item><img src={Canal_Saude} alt='foto' /> 31 - Canal Saúde</ListGroup.Item>
                  <ListGroup.Item><img src={Futura} alt='foto' /> 43 - FUTURA HD</ListGroup.Item>
                  <ListGroup.Item><img src={VGSTV} alt='foto' /> 51 - VGSTV</ListGroup.Item>
                  <ListGroup.Item><img src={Sem_Imagem} alt='foto' /> 57 - TV JOCKEY</ListGroup.Item>
                  <ListGroup.Item><img src={Sem_Imagem} alt='foto' /> 58 - CBED CURSOS HD</ListGroup.Item>
                  <ListGroup.Item><img src={Canal_do_Boi} alt='foto' /> 59 - CANAL DO BOI HD</ListGroup.Item>
                  <ListGroup.Item><img src={Agro_Canal} alt='foto' /> 61 - AGRO CANAL</ListGroup.Item>
                  <ListGroup.Item><img src={TV_Mundo_Maior} alt='foto' /> 62 - TV MUNDO MAIOR HD</ListGroup.Item>
                  <ListGroup.Item><img src={TV_CI} alt='foto' /> 63 - TV CI HD</ListGroup.Item>
                  <ListGroup.Item><img src={JP_News} alt='foto' /> 65 - JP News - Jovem Pan</ListGroup.Item>
                  <ListGroup.Item><img src={SBN_TV} alt='foto' /> 66 - SBN</ListGroup.Item>
                  <ListGroup.Item><img src={REDE_CNT} alt='foto' /> 67 - REDE CNT HD</ListGroup.Item>
                  <ListGroup.Item><img src={Boas_Novas} alt='foto' /> 68 - REDE BOAS NOVAS HD</ListGroup.Item>
                  <ListGroup.Item><img src={Novo_Tempo} alt='foto' /> 69 - TV NOVO TEMPO</ListGroup.Item>
                </ListGroup>
              </Accordion.Body>
            </Accordion.Item>
            <div className="end"></div>
          </Accordion>
        </div>
        <div className="end"></div>
      </div>
    </div>
  )
}
export default Canais;